"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 注册制审核-北交所详情
 */
var web_1 = __importDefault(require("../../../config/web"));
var fieldtools_1 = __importDefault(require("../../../src/modules/commonutil/fieldtools"));
var table_jbxx = $("#table_jbxx");
var table_jgxx = $("#table_jgxx");
var table_cwzb = $("#table_cwzb");
var table_zygd = $("#table_zygd");
var step1 = ["001"], step2 = ["002"], step3 = ["016", "017", "005"], step4 = ["011", "012", "015"], step5 = ["007", "013"];
loadstep();
loadcontent();
function loadstep() {
    getdata({
        reportName: "RPT_BJS_REGIPO_CHECKPROCESS",
        columns: "ORG_CODE,SECURITY_CODE,ORG_NAME_ABBR,CHECK_STATUS,CHECK_STATUS_CODE,END_DATE,SECURITY_INNER_CODE,IS_IT"
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var sysdate = fieldtools_1["default"].dateformat(new Date(), "YYYYMMDD");
            var stepbox = $('.step');
            var curStep = json.result.data.find(function (v) { return (v === null || v === void 0 ? void 0 : v.IS_IT) == 1; });
            var stepNum = getCurStep(curStep === null || curStep === void 0 ? void 0 : curStep.CHECK_STATUS_CODE);
            //遍历状态展示
            //  010终止
            //  009中止
            //  013注册
            //  012报送证监会
            //  011证监会受理
            //  007核准
            //  003上市委会议通过
            //  002已问询
            //  001已受理
            // 暂缓审议 005
            // 核准 007
            // 中止 009
            // 终止 010
            // 证监会受理 011
            // 注册 013
            // 提交注册 015
            // 上市委会议通过 016
            // 上市委会议未通过 017
            for (var i = 0; i < json.result.data.length; i++) {
                var item = json.result.data[i];
                var type = item.CHECK_STATUS_CODE;
                var date = item.END_DATE.substring(0, 10).replace(/-/g, '');
                //是否是已发生过的日期
                var b = date <= sysdate;
                if (step1.includes(type) && stepNum >= 1) {
                    $('.step1F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b)
                        $('.step1F', stepbox).removeClass("left01").addClass("left03");
                }
                if (step2.includes(type) && stepNum >= 2) {
                    $('.step2F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b)
                        $('.step2F', stepbox).removeClass("center01").addClass("center05");
                }
                if (step3.includes(type) && stepNum >= 3) {
                    $('.step3F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step3F', stepbox).removeClass("center01").addClass("center05");
                        $('.step3F .step_text', stepbox).html(item.CHECK_STATUS);
                    }
                }
                if (step4.includes(type) && stepNum >= 4) {
                    $('.step4F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b)
                        $('.step4F', stepbox).removeClass("center01").addClass("center05");
                    $('.step4F .step_title', stepbox).html(item.CHECK_STATUS);
                }
                if (step5.includes(type) && stepNum == 5) {
                    $('.step5F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step5F', stepbox).removeClass("center01").addClass("right02");
                        $('.step5F .step_text', stepbox).html(item.CHECK_STATUS);
                    }
                }
            }
            //判断最终状态
            switch (info.CHECK_STATUS_CODE) {
                case '009':
                case '010':
                    {
                        if ($(".center05:last", stepbox).length > 0) {
                            $(".center05:last", stepbox).removeClass("center05").addClass("center06").find(".step_text").html("<div>" + info.CHECK_STATUS + "<br/>" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "<div>");
                            ;
                        }
                        else {
                            $(".left03:last", stepbox).removeClass("left03").addClass("left04").find(".step_text").html("<div>" + info.CHECK_STATUS + "<br/>" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "<div>");
                            ;
                        }
                        break;
                    }
            }
        }
    });
}
function loadcontent() {
    //infocode
    fieldtools_1["default"].isEmpty(info.INFO_CODE) ? undefined : $("#pdfurl").attr('href', "https://pdf.dfcfw.com/pdf/H2_" + info.INFO_CODE + "_1.pdf").show();
    //基本信息
    $(".ISSUER_NAME", table_jbxx).html(info.ISSUER_NAME); //发行人全称	ISSUER_NAME
    $(".ACCEPT_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.ACCEPT_DATE)); //受理日期	ACCEPT_DATE
    $(".SECURITY_NAME_ABBR", table_jbxx).html(info.SECURITY_NAME_ABBR); //公司简称	SECURITY_NAME_ABBR
    $(".FINANCE_AMT", table_jbxx).html(info.FINANCE_AMT); //融资金额	FINANCE_AMT
    $(".CHECK_STATUS", table_jbxx).html(info.CHECK_STATUS); //审核状态	CHECK_STATUS
    $(".UPDATE_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.UPDATE_DATE)); //更新日期	UPDATE_DATE
    $(".REG_ADDRESS", table_jbxx).html(info.REG_ADDRESS); //注册地	REG_ADDRESS
    $(".CSRC_INDUSTRY", table_jbxx).html(info.CSRC_INDUSTRY); //证监会行业	CSRC_INDUSTRY
    $(".RECOMMEND_ORG", table_jbxx).html(info.RECOMMEND_ORG); //保荐机构	RECOMMEND_ORG
    $(".SPONSOR", table_jbxx).html(info.SPONSOR); //保荐代表人	SPONSOR
    $(".ACCOUNT_FIRM", table_jbxx).html(info.ACCOUNT_FIRM); //会计师事务所	ACCOUNT_FIRM
    $(".SIGN_ACCOUNTANT", table_jbxx).html(info.SIGN_ACCOUNTANT); //签字会计师	SIGN_ACCOUNTANT
    $(".LAW_FIRM", table_jbxx).html(info.LAW_FIRM); //律师事务所	LAW_FIRM
    $(".SIGN_LAWYER", table_jbxx).html(info.SIGN_LAWYER); //签字律师	SIGN_LAWYER
    $(".EVALUATE_ORG", table_jbxx).html(info.EVALUATE_ORG); //评估机构	EVALUATE_ORG
    $(".SIGN_APPRAISER", table_jbxx).html(info.SIGN_APPRAISER); //签字评估师	SIGN_APPRAISER
    $(".TOLIST_MARKET", table_jbxx).html(info.TOLIST_MARKET); //拟上市地点	TOLIST_MARKET
    $(".STATE", table_jbxx).html(info.STATE); //证监会注册状态	STATE
    $(".END_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.END_DATE)); //证监会更新日期	END_DATE
    //机构信息
    getdata({
        reportName: "RPT_HSF9_BASIC_ORGINFO",
        columns: "REG_ADDRESS,FOUND_DATE,LEGAL_PERSON,CHAIRMAN,ORG_PROFILE,BUSINESS_SCOPE"
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".REG_ADDRESS", table_jgxx).html(data.REG_ADDRESS); //注册地	REG_ADDRESS
            $(".FOUND_DATE", table_jgxx).html(fieldtools_1["default"].dateformat(data.FOUND_DATE)); //成立日期	FOUND_DATE
            $(".LEGAL_PERSON", table_jgxx).html(data.LEGAL_PERSON); // 法人代表	LEGAL_PERSON
            $(".CHAIRMAN", table_jgxx).html(data.CHAIRMAN); // 董事长	CHAIRMAN
            $(".ORG_PROFILE", table_jgxx).html(data.ORG_PROFILE); //公司简介	ORG_PROFILE
            $(".BUSINESS_SCOPE", table_jgxx).html(data.BUSINESS_SCOPE); //经营范围	BUSINESS_SCOPE
        }
    });
    //财务数据
    getdata({
        reportName: "RPT_FNINDICATOR_DECLARE",
        columns: "REPORT_DATE,TOTAL_ASSETS_ADJUST,TOTAL_EQUITY_ADJUST,TOTAL_EQUITY_ADJUST,MINORITY_EQUITY_ADJUST,TOTAL_OPERATE_INCOME,PARENT_NETPROFIT,CAPITAL_RESERVE_ADJUST,UNASSIGN_RPOFIT_ADJUST,PARENT_BVPS_ADJUST,BASIC_EPS_ADJUST,DILUTED_EPS_ADJUST,PER_NETCASHOPERATE_ADJUST,ROE_WEIGHT_FN,REPORT_TYPE",
        sortColumns: "REPORT_DATE",
        sortTypes: -1,
        pageSize: 4,
        filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")(REPORT_TYPE=\"\u5E74\u5EA6\u62A5\u544A\")(REPORT_DATE<='" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "')"
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            for (var i = 0; i < 4; i++) {
                if (json.result.data[i])
                    loadcell(i + 1, json.result.data[i]);
                else
                    delcell(i + 1);
            }
        }
    });
    //主要股东
    getdata({
        reportName: "RPT_HOLDERSDECLARE_BJ",
        columns: "HOLD_NUM,HOLD_RATIO,HOLDER_NAME,NUM_SUM,RATIO_SUM,RANK,END_DATE",
        sortColumns: "RANK",
        sortTypes: 1
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            var list = json.result.data;
            var count = list.length;
            for (var i = 0; i < count; i++) {
                var item = list[i];
                var tds = $("tr", table_zygd).eq(i + 1);
                $("td", tds).eq(0).html(item.RANK);
                $("td", tds).eq(1).html('<div class="ellipsis" style="width: 550px;">' + item.HOLDER_NAME + '</div>').attr("title", item.HOLDER_NAME);
                $("td", tds).eq(2).html(item.HOLD_NUM);
                $("td", tds).eq(3).html(item.HOLD_RATIO);
            }
            $("td", $("tr", table_zygd).eq(11)).eq(1).html(list[0].NUM_SUM);
            $("td", $("tr", table_zygd).eq(11)).eq(2).html(list[0].RATIO_SUM);
            for (var i_1 = count; i_1 < 10; i_1++) {
                $("tr", table_zygd).eq(count + 1).remove();
            }
            $("#date_zygd").html("截止日期:" + fieldtools_1["default"].dateformat(list[0].END_DATE, 'YYYY-MM-DD 周W'));
        }
    });
    //最新公告
    $("#dataview_zxgg").emdataview({
        columns: {
            title: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis\" style=\"width:600px;\" href=\"//pdf.dfcfw.com/pdf/H2_" + item.art_code + "_1.pdf\" title=\"" + value + "\">" + value + "</a>";
                }
            },
            column_name: {
                formatter: function (value, item, i, field) {
                    var _a;
                    return ((_a = item.columns[0]) === null || _a === void 0 ? void 0 : _a.column_name) || '-';
                }
            },
            notice_date: emfield.date
        }
    });
}
function getdata(opt) {
    return $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: "GET",
        dataType: "jsonp",
        data: $.extend({}, {
            filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")",
            columns: 'ALL',
            source: "WEB",
            client: "WEB"
        }, opt)
    });
}
function loadcell(index, data) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).html(fieldtools_1["default"].dateformat(data.REPORT_DATE)); //报表日期	REPORT_DATE
    $(".TOTAL_ASSETS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_ASSETS_ADJUST, { omit: false, zoom: -8, num: 4 })); //总资产	TOTAL_ASSETS_ADJUST
    $(".TOTAL_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_EQUITY_ADJUST, { omit: false, zoom: -8, num: 4 })); //净资产	TOTAL_EQUITY_ADJUST
    $(".MINORITY_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.MINORITY_EQUITY_ADJUST, { omit: false, zoom: -4, num: 2 })); //少数股东权益	MINORITY_EQUITY_ADJUST
    $(".TOTAL_OPERATE_INCOME td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_OPERATE_INCOME, { omit: false, zoom: -8, num: 4 })); //营业总收入	TOTAL_OPERATE_INCOME
    $(".PARENT_NETPROFIT td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_NETPROFIT, { omit: false, zoom: -8, num: 4 })); //净利润	PARENT_NETPROFIT
    $(".CAPITAL_RESERVE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.CAPITAL_RESERVE_ADJUST, { omit: false, zoom: -4, num: 2 })); //资本公积	CAPITAL_RESERVE_ADJUST
    $(".UNASSIGN_RPOFIT_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.UNASSIGN_RPOFIT_ADJUST, { omit: false, zoom: -8, num: 4 })); //未分配利润	UNASSIGN_RPOFIT_ADJUST
    $(".PARENT_BVPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_BVPS_ADJUST)); //每股净资产	PARENT_BVPS_ADJUST
    $(".BASIC_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.BASIC_EPS_ADJUST)); //基本每股收益	BASIC_EPS_ADJUST
    $(".DILUTED_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.DILUTED_EPS_ADJUST)); //稀释每股收益	DILUTED_EPS_ADJUST
    $(".PER_NETCASHOPERATE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PER_NETCASHOPERATE_ADJUST)); //每股现金流	PER_NETCASHOPERATE_ADJUST
    $(".ROE_WEIGHT_FN td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.ROE_WEIGHT_FN)); //净资产收益率	ROE_WEIGHT_FN
}
function delcell(index) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).remove();
    $("tr:not(.REPORT_DATE)", table_cwzb).find("td:eq(" + index + ")").remove();
}
/**
 * 获取当前进度步骤
 */
function getCurStep(CHECK_STATUS) {
    var back = 5;
    try {
        var allsteps = [step1, step2, step3, step4, step5];
        allsteps.forEach(function (step, index) {
            if (step.includes(CHECK_STATUS)) {
                back = index + 1;
            }
            ;
        });
        return back;
    }
    catch (error) {
        return 5;
    }
}
